import { Configuration } from "@bohe-in/treau-api-client-ts";

const axiosConfig = new Configuration({
  baseOptions: {
    withCredentials: true,
  }
});

const allowDenaliDefaultFirmware = (process.env.REACT_APP_ALLOW_DENALI_DEFAULT_FIRMWARE || "true") === "true";

let local = {
    treauApi:{
        endpoint: process.env.REACT_APP_API_ORIGIN || "http://localhost:5001"
    },
    axiosConfig,
    allowDenaliDefaultFirmware,
};

let dev = {
    treauApi:{
      endpoint: "https://api.cloud-dev.gradientcomfort.com"
    },
    axiosConfig,
    allowDenaliDefaultFirmware,
};

let prod = {
    treauApi:{
        endpoint: "https://api.cloud.gradientcomfort.com"
    },
    axiosConfig,
    allowDenaliDefaultFirmware,
};

const config  = () =>{
    console.log(process.env.REACT_APP_ENV);
    return process.env.REACT_APP_ENV === "prod"?prod:process.env.REACT_APP_ENV === "dev"?dev:local;
};

export default config();
